import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography } from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";

const OpeningBalanceDateModal = ({ open, onClose, onConfirm }) => {
    const [date, setDate] = React.useState("");

    const { financialYear } = useSelector((state) => state.userPrefrenceandReducer)

    const handleConfirm = () => {
        if (date) {
            onConfirm(date);
            onClose(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ backgroundColor: "primary.main", p: "8px" }}>
                <Typography variant="h3" fontSize="18px">
                    Set Opening Balance Date
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ p: "8px", mt: "8px" }}>
                <Typography variant="body1" gutterBottom>
                    You are setting an <strong>Opening Balance</strong> for the imported ledgers.
                </Typography>
                <Typography variant="body2" gutterBottom>
                    Please select the date for this opening balance to ensure accurate financial records.
                </Typography>

                <TextField
                    label="Opening Balance Date"
                    type="date"
                    fullWidth
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    sx={{ mt: 2 }}
                    InputProps={{
                        inputProps: {
                            min: moment(financialYear?.startdate * 1000).format("YYYY-MM-DD"),
                            max: moment(financialYear?.enddate * 1000).format("YYYY-MM-DD"),
                        },
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)} color="secondary">Cancel</Button>
                <Button onClick={handleConfirm} color="primary" variant="contained" disabled={!date}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OpeningBalanceDateModal;
